export default __webpack_public_path__ + "static/media/FeatureImage.d784ae73.png";